import { Grid } from "@mui/material";
import useTranslation from "../../hooks/useTranslation";
import { GetSurveyChapterScoringResponse } from "../../types/workplaceCulture";
import {
  getChapterBenchmarkScore,
  getDemographicTotalScore,
} from "../../utils/WorkplaceCulture.utils";
import { ScoreCard } from "../ScoreCard/ScoreCard";
import { Paper } from "../ui/Paper/Paper";
import { Typography } from "../ui/Typography/Typography";
import "./ReportChapterScores.scss";

interface ReportChapterScoresProps {
  chapterScoringData?: GetSurveyChapterScoringResponse;
}

export const ReportChapterScores = ({
  chapterScoringData,
}: ReportChapterScoresProps) => {
  const { t } = useTranslation("reportPage");
  const chapters = chapterScoringData?.chapters || [];

  return (
    <div className="ReportChapterScores">
      <Typography
        tagVariant="h2"
        desktop="h2"
        className="ReportChapterScores__title"
        color="darkerStoneBlue"
      >
        {t("chapterScores.title")}
      </Typography>

      <Grid container spacing={2}>
        {chapters.map((chapter) => {
          const score = getDemographicTotalScore(chapter.demographic);

          let benchmarkScore = getChapterBenchmarkScore(chapter.id);

          return (
            <Grid item xs={12} sm={4} md={4} key={chapter.id}>
              <Paper
                key={chapter.id}
                shadow
                className="ReportChapterScores__chapterCard"
              >
                <ScoreCard
                  title={chapter.name}
                  score={score}
                  image={chapter.image}
                  imageAlt={chapter.name}
                  info={chapter.description}
                  scoreSize="medium"
                  label={t("chapterScores.benchmarkingLabel", {
                    score: benchmarkScore.toFixed(2),
                  })}
                />
              </Paper>
            </Grid>
          );
        })}
      </Grid>

      {chapters.length === 0 && (
        <div className="ReportChapterScores__noData">
          <Typography
            desktop="body1"
            fontStyle="italic"
            color="darkerStoneBlue"
          >
            {t("chapterScores.noData")}
          </Typography>
        </div>
      )}
    </div>
  );
};
